import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './ProjectTeamRow.module.css';
import { useProjectTeamRow } from './useProjectTeamRow';
import { Roles } from '../../../../../../TemporaryConmonents/AddProject/types/types';
import { PeopleCard } from '../PeopleCard/PeopleCard';
import { EmployersForSelect } from '../../../../../../TemporaryConmonents/AddProject/SecondStep/useSecondStep';
import { OpenedInviteCard } from '../../../../../../TemporaryConmonents/ProjectTeam/ProjectTeamInvite/useProjectTeamInvite';
import { InviteCard } from '../../../../../../TemporaryConmonents/ProjectTeam/ProjectTeamInvite/UI/InviteCard/InviteCard';
import { useTranslation } from 'react-i18next';

interface ProjectTeamRowProps {
    classes?: string;
    role: Roles;
    openedInviteCard: OpenedInviteCard;
    onOpenedInviteCardChange: (value: OpenedInviteCard) => void;
    employersList: EmployersForSelect[];
    onEmployersListSet: (value: string) => void;
    closingCard: string;
    onSetClosingCard: (value: string | null) => void;
}

export const ProjectTeamRow = memo(
    ({
        classes,
        role,
        openedInviteCard,
        onOpenedInviteCardChange,
        employersList,
        onEmployersListSet,
        onSetClosingCard,
        closingCard,
    }: ProjectTeamRowProps) => {
        const { t } = useTranslation();

        const headerMapping = {
            manager: t('ProjectTeamRow.headerMapping.manager'),
            foreman: t('ProjectTeamRow.headerMapping.foreman'),
            purchaser: t('ProjectTeamRow.headerMapping.purchaser'),
        };

        const { project_users, is_customer, can_show_financial_info } = useProjectTeamRow();

        if (!can_show_financial_info && project_users[role].length === 0) {
            return null;
        }
        return (
            <div className={classNames(cls.ProjectTeamRow, [classes])}>
                <div>
                    <h3 className={cls.rowHeader}>{headerMapping[role]}</h3>
                </div>
                <div className={cls.rowContent}>
                    {!is_customer && can_show_financial_info && (
                        <InviteCard
                            closingCard={closingCard}
                            onSetClosingCard={onSetClosingCard}
                            isDash={true}
                            onEmployersListSet={onEmployersListSet}
                            employersList={employersList}
                            type={role}
                            openedInviteCard={openedInviteCard}
                            onOpenedInviteCardChange={onOpenedInviteCardChange}
                        />
                    )}
                    {project_users[role].map((user) => (
                        <PeopleCard key={user.id} user={user} role={role} />
                    ))}
                </div>
            </div>
        );
    }
);
